import { createSlice } from '@reduxjs/toolkit';

const STORAGE_KEY = 'enabledSources';
const METADATA_FILTER_KEY = 'hideIncompleteMetadata';

// Default enabled sources - STREAMING SERVICES ONLY
const DEFAULT_ENABLED_SOURCES = [
  'PlutoTV',
  'TubiTV',
  'Plex',
  'RokuChannel',
  'XumoPlay'
];

// Load from localStorage or use defaults
const loadEnabledSources = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : DEFAULT_ENABLED_SOURCES;
  } catch (error) {
    console.error('Error loading enabled sources:', error);
    return DEFAULT_ENABLED_SOURCES;
  }
};

const loadMetadataFilter = () => {
  try {
    const saved = localStorage.getItem(METADATA_FILTER_KEY);
    return saved ? JSON.parse(saved) : false;
  } catch (error) {
    console.error('Error loading metadata filter:', error);
    return false;
  }
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    enabledSources: loadEnabledSources(),
    hideIncompleteMetadata: loadMetadataFilter(),
    allSources: [
      'PlutoTV',
      'TubiTV',
      'Plex',
      'RokuChannel',
      'XumoPlay'
    ]
  },
  reducers: {
    toggleSource: (state, action) => {
      const source = action.payload;
      if (state.enabledSources.includes(source)) {
        state.enabledSources = state.enabledSources.filter(s => s !== source);
      } else {
        state.enabledSources.push(source);
      }
      // Save to localStorage
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state.enabledSources));
    },
    setEnabledSources: (state, action) => {
      state.enabledSources = action.payload;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state.enabledSources));
    },
    resetToDefaults: (state) => {
      state.enabledSources = DEFAULT_ENABLED_SOURCES;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(DEFAULT_ENABLED_SOURCES));
    },
    toggleMetadataFilter: (state) => {
      state.hideIncompleteMetadata = !state.hideIncompleteMetadata;
      localStorage.setItem(METADATA_FILTER_KEY, JSON.stringify(state.hideIncompleteMetadata));
    },
    setMetadataFilter: (state, action) => {
      state.hideIncompleteMetadata = action.payload;
      localStorage.setItem(METADATA_FILTER_KEY, JSON.stringify(state.hideIncompleteMetadata));
    }
  }
});

export const { toggleSource, setEnabledSources, resetToDefaults, toggleMetadataFilter, setMetadataFilter } = settingsSlice.actions;
export default settingsSlice.reducer;
